import cmfApi from "./index";

export const getLogin = (data, code) =>
	cmfApi.post(`/login${code ? `/${code}` : ''}`, data);
